import { Purpose } from '../enums/purpose';
import { FloorTypes } from '../enums/floorTypes.enum';
import { DoorPosition } from './doorPosition.model';
import { WallFinish } from './wallFinish.model';
import { WallSide } from '../enums/wallSide.enum';
import { DoorType } from '../enums/doorType.enum';
import { FinishTypes } from '../enums/finishTypes.enum';
import { InnerWall } from './innerWall.model';
import { DoorDirection } from '../enums/doorDirection.enum';
import { HingeType } from '../enums/hingeType.enum';
import { DoorHandleType } from '../enums/doorHandleType.enum';
import { ProductClass } from '../enums/productClass.enum';

export class Settings {
  purpose: Purpose = Purpose.Cooling;
  wallThickness = 80;
  lengthInMM = 2100;
  widthInMM = 2100;
  heightInMM = 2100;
  innerWalls: InnerWall[] = [];
  floorType = FloorTypes.DURAFLOOR;
  sunkenFloor = false;
  ventilationProfiles = true;
  ceilingMoldings = false;
  productClass: ProductClass = ProductClass.STANDARD;
  _doorSettings: DoorPosition[] = [
    new DoorPosition(
      1,
      600,
      WallSide.south,
      900,
      1985,
      1200,
      2100,
      FinishTypes.STEEL,
      FinishTypes.STEEL,
      FinishTypes.STEEL,
      FinishTypes.STEEL,
      DoorType.Turn,
      DoorDirection.left,
      HingeType.normal,
      DoorHandleType.euro2015
    ),
  ];

  wallFinishes: Record<WallSide, WallFinish>;

  plinthsInside = false;
  plinthsOutside = false;
  itemId = 'PBM.000.002';
  salesPrice: number;
  salesTotal: number;

  constructor() {
    this.wallFinishes = {
      [WallSide.north]: new WallFinish(WallSide.north),
      [WallSide.east]: new WallFinish(WallSide.east),
      [WallSide.south]: new WallFinish(WallSide.south),
      [WallSide.west]: new WallFinish(WallSide.west),
      [WallSide.inner]: new WallFinish(WallSide.inner),
      [WallSide.ceiling]: new WallFinish(WallSide.ceiling),
      [WallSide.floor]: new WallFinish(WallSide.floor),
    };
  }
  get doorSettings(): DoorPosition[] {
    return this._doorSettings;
  }

  set doorSettings(value: DoorPosition[]) {
    this._doorSettings = value;
  }

  clone(): Settings {
    const clone = new Settings();
    clone._doorSettings = [];
    this._doorSettings.forEach(ds => {
      const newSetting = ds.clone();
      clone._doorSettings.push(newSetting);
    });
    if (this.ceilingMoldings !== undefined) {
      clone.ceilingMoldings = this.ceilingMoldings.valueOf();
    }
    if (this.floorType !== undefined) {
      clone.floorType = this.floorType.valueOf() as FloorTypes;
    }
    if (this.heightInMM !== undefined) {
      clone.heightInMM = this.heightInMM.valueOf();
    }
    if (this.itemId !== undefined) {
      clone.itemId = this.itemId.valueOf();
    }
    if (this.lengthInMM !== undefined) {
      clone.lengthInMM = this.lengthInMM.valueOf();
    }
    if (this.plinthsInside !== undefined) {
      clone.plinthsInside = this.plinthsInside.valueOf();
    }
    if (this.plinthsOutside !== undefined) {
      clone.plinthsOutside = this.plinthsOutside.valueOf();
    }
    if (this.purpose !== undefined) {
      clone.purpose = this.purpose.valueOf();
    }
    if (this.salesPrice !== undefined) {
      clone.salesPrice = this.salesPrice.valueOf();
    }
    if (this.salesTotal !== undefined) {
      clone.salesTotal = this.salesTotal.valueOf();
    }

    if (this.sunkenFloor !== undefined) {
      clone.sunkenFloor = this.sunkenFloor.valueOf();
    }
    if (this.ventilationProfiles !== undefined) {
      clone.ventilationProfiles = this.ventilationProfiles.valueOf();
    }

    for (let i = 0; i < Object.values(this.wallFinishes).length; i++) {
      clone.wallFinishes[i] = Object.assign(new WallFinish(0), this.wallFinishes[i]);
    }

    if (this.wallThickness !== undefined) {
      clone.wallThickness = this.wallThickness.valueOf();
    }
    if (this.widthInMM !== undefined) {
      clone.widthInMM = this.widthInMM.valueOf();
    }
    return clone;
  }
}
